import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegionBaseService {
  constructor() {}
  getProvince(): Observable<any> {
    return;
  }

  getCitys(name: string): Observable<any> {
    return;
  }

  getCitysByCode(code: string): Observable<any> {
    return;
  }
}
